import { FunctionComponent, useState } from 'react'

interface WrapperProps {
  children: React.ReactElement
  validator: (value: string) => boolean
  value: string
  disableDisclose?: boolean
}

const Wrapper: FunctionComponent<WrapperProps> = ({
  children,
  validator,
  value,
  disableDisclose
}) => {
  const [isPathCompleted, setIsPathCompleted] = useState(false)

  if (isPathCompleted || disableDisclose) {
    return children
  }

  if (validator(value)) {
    setIsPathCompleted(true)
    return children
  }
  return null
}

export default Wrapper
